import { useMutation, useQuery } from "@apollo/client";
import { Grid } from "@mui/material";
import FormSkeleton from "components/FormSkeleton/FormSkeleton";
import MDAlert from "components/MDAlert";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import CustomEditor from "modules/custom/CustomEditor";
import { PRODUCTS, UPDATE_LIBRARY_PRODUCT } from "modules/custom/api";
import { customInput } from "modules/custom/calculator";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getRoute } from "utils/routing";

export default function CustomProductUpdatePage() {
  const navigate = useNavigate();
  const { productId, productTypeId } = useParams();
  const { data, loading, error } = useQuery(PRODUCTS, { fetchPolicy: "network-only" });
  const [update] = useMutation(UPDATE_LIBRARY_PRODUCT);
  const product = data?.customProducts.find(
    (p: any) => p.id === productId && p.organizationProductType.id === productTypeId
  );
  return (
    <DashboardPage>
      {loading && <FormSkeleton rows={4} />}
      {error && <MDAlert color="error">{error.message}</MDAlert>}
      {!loading && !error && !product && (
        <MDAlert color="error">This Custom product is unavailable or has been deleted.</MDAlert>
      )}
      {!loading && !error && product && (
        <>
          <MDBox mb={6}>
            <Grid container alignItems="center" justifyContent="space-between">
              <MDTypography variant="h4" fontWeight="medium">
                Update Product - {product.definition.internalName || product.definition.name}
              </MDTypography>
              <MDButton
                component={Link}
                to={getRoute("product-types.view", [["productTypeId", productTypeId]])}
                color="blue"
              >
                Back to Products
              </MDButton>
            </Grid>
          </MDBox>
          <CustomEditor
            key={product.id}
            initial={product.definition}
            presentation="library-form"
            productTypeName={product.organizationProductType.name}
            initiallyExpanded
            saveLabel="Save Product"
            onSave={async (input) => {
              await update({
                variables: {
                  id: product.id,
                  expectedRevision: product.revision,
                  input: customInput(input),
                },
                refetchQueries: [PRODUCTS],
                awaitRefetchQueries: true,
              });
              navigate(getRoute("product-types.products.list", [["productTypeId", productTypeId]]));
            }}
          />
        </>
      )}
    </DashboardPage>
  );
}
